(function () {
  'use strict';

  var MOCKUP_SET_STORAGE_KEY = 'havjoy_mockup_sets_v1';
  var MOCKUP_WAIT_TIMEOUT_MS = 45 * 1000;

  function normalizeMockupVariantName(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
  }

  function readStoredMockupSets() {
    try {
      var value = JSON.parse(window.localStorage.getItem(MOCKUP_SET_STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function findStoredMockup(currentUrl, productType) {
    var normalizedType = normalizeMockupVariantName(productType);
    var matchedSet = readStoredMockupSets().find(function (item) {
      return item && Array.isArray(item.urls) && item.urls.indexOf(currentUrl) !== -1;
    });
    return {
      foundSet: !!matchedSet,
      url: matchedSet && matchedSet.variants && typeof matchedSet.variants[normalizedType] === 'string'
        ? matchedSet.variants[normalizedType] : ''
    };
  }

  function announceCartUpdate(message) {
    var liveRegion = document.getElementById('CartDrawer-LiveRegionText');
    if (liveRegion) liveRegion.textContent = message || '';
  }

  function waitForStoredMockup(currentUrl, productType) {
    var initial = findStoredMockup(currentUrl, productType);
    if (initial.url) return Promise.resolve(initial.url);
    if (!initial.foundSet) return Promise.reject(new Error('Mockup variants are unavailable for this cart item.'));

    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer;
      var interval;
      function cleanup() {
        window.clearTimeout(timer);
        window.clearInterval(interval);
        window.removeEventListener('havjoy:mockup-set-updated', check);
      }
      function finish(callback, value) {
        if (settled) return;
        settled = true;
        cleanup();
        callback(value);
      }
      function check() {
        var result = findStoredMockup(currentUrl, productType);
        if (result.url) finish(resolve, result.url);
      }
      window.addEventListener('havjoy:mockup-set-updated', check);
      interval = window.setInterval(check, 300);
      timer = window.setTimeout(function () {
        finish(reject, new Error('The selected mockup is still being prepared. Please try again.'));
      }, MOCKUP_WAIT_TIMEOUT_MS);
      check();
    });
  }

  function closestAction(event) {
    return event.target.closest('[data-action]');
  }

  function getLineCard(target) {
    return target.closest('[data-item-key]');
  }

  function getQtyFromCard(card) {
    var qtyEl = card && card.querySelector('[data-qty-display]');
    return qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
  }

  function syncSummaryDetails() {
    document.querySelectorAll('[data-cart-summary-details]').forEach(function (details) {
      details.open = false;
    });
  }

  function updateStickyCheckout(sectionHtml, itemCount) {
    var currentBar = document.getElementById('havjoy-sticky-checkout');
    if (!currentBar) return;

    var nextBar = null;
    if (sectionHtml) {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      nextBar = doc.getElementById('havjoy-sticky-checkout');
    }

    var nextItemCount = typeof itemCount === 'number'
      ? itemCount
      : Number(nextBar && nextBar.dataset.itemCount || 0);
    currentBar.dataset.itemCount = String(nextItemCount);

    var nextTotal = nextBar && nextBar.querySelector('.havjoy-sticky-checkout__total');
    var currentTotal = currentBar.querySelector('.havjoy-sticky-checkout__total');
    if (nextTotal && currentTotal) currentTotal.textContent = nextTotal.textContent.trim();

    var isVisible = nextItemCount > 0;
    currentBar.classList.toggle('is-visible', isVisible);
    currentBar.setAttribute('aria-hidden', String(!isVisible));
  }

  function updateCartIcon(sectionHtml, itemCount) {
    var currentIcon = document.getElementById('cart-icon-bubble');
    if (!currentIcon) return;

    if (sectionHtml) {
      var iconDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var sectionRoot = iconDoc.getElementById('shopify-section-cart-icon-bubble') ||
        iconDoc.querySelector('[id$="__cart-icon-bubble"]');
      var nextMarkup = sectionRoot ? sectionRoot.innerHTML : iconDoc.body.innerHTML;
      if (nextMarkup.trim()) currentIcon.innerHTML = nextMarkup;
    }

    // The cart-icon-bubble section renders only the icon contents, not the header link.
    // Always clear a stale badge when Shopify's authoritative cart state is empty.
    if (itemCount === 0) {
      currentIcon.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
        bubble.remove();
      });
    }
  }

  function renderSections(sections, cartState) {
    if (!sections) return Promise.resolve();

    return Promise.resolve().then(function () {
      var parser = new DOMParser();
      var cartDrawer = document.querySelector('cart-drawer');
      var itemCount = cartState && typeof cartState.item_count === 'number'
        ? cartState.item_count
        : undefined;

      if (sections['cart-drawer'] && cartDrawer) {
        var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var nextCartDrawer = drawerDoc.querySelector('cart-drawer');
        var nextCartDrawerInner = drawerDoc.querySelector('#CartDrawer');
        var currentCartDrawerInner = document.getElementById('CartDrawer');

        if (nextCartDrawer) {
          cartDrawer.classList.toggle('is-empty', nextCartDrawer.classList.contains('is-empty'));
        }

        if (nextCartDrawerInner && currentCartDrawerInner) {
          currentCartDrawerInner.innerHTML = nextCartDrawerInner.innerHTML;
        }

        var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cartDrawer.close === 'function') {
          overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
      }

      if (sections['main-cart-items']) {
        var pageDoc = parser.parseFromString(sections['main-cart-items'], 'text/html');
        var nextPage = pageDoc.querySelector('.hj-cart-page');
        var currentPage = document.querySelector('.hj-cart-page');
        if (nextPage && currentPage) currentPage.innerHTML = nextPage.innerHTML;
      }

      if (sections['main-cart-footer']) {
        var footerDoc = parser.parseFromString(sections['main-cart-footer'], 'text/html');
        var nextFooter = footerDoc.getElementById('main-cart-footer');
        var currentFooter = document.getElementById('main-cart-footer');
        if (nextFooter && currentFooter) currentFooter.innerHTML = nextFooter.innerHTML;
      }

      updateCartIcon(sections['cart-icon-bubble'], itemCount);
      updateStickyCheckout(sections['havjoy-sticky-checkout'], itemCount);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hj-cart', cartData: cartState });
      }

      syncSummaryDetails();
    });
  }

  function refreshCart(cartState) {
    var sectionsRequest = fetch('/cart?sections=cart-drawer,main-cart-items,main-cart-footer,cart-icon-bubble,havjoy-sticky-checkout')
      .then(function (response) {
        if (!response.ok) throw new Error('Cart sections refresh failed');
        return response.json();
      });
    var hasAuthoritativeCart = cartState && typeof cartState.item_count === 'number';
    var cartRequest = hasAuthoritativeCart
      ? Promise.resolve(cartState)
      : fetch('/cart.js').then(function (response) {
        if (!response.ok) throw new Error('Cart state refresh failed');
        return response.json();
      });

    return Promise.all([sectionsRequest, cartRequest]).then(function (results) {
      return renderSections(results[0], results[1]);
    });
  }

  function setCardBusy(card, isBusy) {
    if (!card) return;
    card.classList.toggle('is-updating', isBusy);
    card.setAttribute('aria-busy', String(isBusy));
  }

  function updateLine(lineKey, quantity, card) {
    setCardBusy(card, true);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, quantity) })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    }).then(refreshCart).catch(function (error) {
      console.error('[hj-cart] update failed', error);
      return refreshCart();
    }).finally(function () {
      setCardBusy(card, false);
    });
  }

  function getCartLine(lineKey) {
    return fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        return cart.items.find(function (item) { return item.key === lineKey; });
      });
  }

  function changeVariant(lineKey, variantId, card, options) {
    setCardBusy(card, true);
    options = options || {};

    return getCartLine(lineKey).then(function (line) {
      if (!line) return;
      var properties = Object.assign({}, line.properties || {});
      var prepareProperties = Promise.resolve(properties);
      if (options.updateMockup && typeof properties._your_design === 'string' && properties._your_design) {
        announceCartUpdate('Preparing the selected product mockup…');
        prepareProperties = waitForStoredMockup(properties._your_design, options.productType).then(function (mockupUrl) {
          properties._your_design = mockupUrl;
          return properties;
        });
      }

      return prepareProperties.then(function (nextProperties) { return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).then(function (response) {
        if (!response.ok) throw new Error('Variant remove failed');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: line.quantity,
              properties: nextProperties
            }]
          })
        });
      }); }).then(function (response) {
        if (!response.ok) throw new Error('Variant add failed');
        return response.json();
      }).then(refreshCart).then(function (result) {
        announceCartUpdate('Product option updated.');
        return result;
      });
    }).catch(function (error) {
      console.error('[hj-cart] variant change failed', error);
      announceCartUpdate(error.message || 'Could not update this product option.');
      return refreshCart();
    }).finally(function () {
      setCardBusy(card, false);
    });
  }

  function changeOption(select, card) {
    if (!card) return;
    var data = card.querySelector('[data-cart-product-variants]');
    var selects = Array.prototype.slice.call(card.querySelectorAll('[data-action="change-option"]'));
    if (!data || !selects.length) return;
    var variants;
    try { variants = JSON.parse(data.textContent || '[]'); }
    catch (error) { variants = []; }
    var values = selects.map(function (item) { return item.value; });
    var variant = variants.find(function (item) {
      return item && item.available !== false && Array.isArray(item.options) && item.options.every(function (value, index) {
        return String(value) === String(values[index]);
      });
    });
    if (!variant) {
      refreshCart();
      return;
    }
    var productTypeSelect = selects.find(function (item) {
      return normalizeMockupVariantName(item.dataset.optionName) === 'product type';
    });
    changeVariant(select.dataset.lineKey, variant.id, card, {
      updateMockup: select === productTypeSelect,
      productType: productTypeSelect ? productTypeSelect.value : ''
    });
  }

  function setCartOptionOpen(combo, isOpen, focusSelected) {
    if (!combo) return;
    var trigger = combo.querySelector('[data-action="toggle-cart-option"]');
    var list = combo.querySelector('.hj-cart-item__option-list');
    var card = combo.closest('.hj-cart-item');
    combo.classList.toggle('is-open', isOpen);
    combo.classList.remove('opens-up');
    if (card) card.classList.toggle('has-open-option', isOpen);
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (list) list.hidden = !isOpen;
    if (isOpen && trigger && list) {
      var boundary = combo.closest('cart-drawer-items') || document.documentElement;
      var boundaryRect = boundary.getBoundingClientRect();
      var triggerRect = trigger.getBoundingClientRect();
      var topLimit = Math.max(0, boundaryRect.top);
      var bottomLimit = Math.min(window.innerHeight, boundaryRect.bottom);
      var menuHeight = Math.min(list.scrollHeight, 220) + 5;
      var spaceBelow = bottomLimit - triggerRect.bottom;
      var spaceAbove = triggerRect.top - topLimit;
      combo.classList.toggle('opens-up', spaceBelow < menuHeight && spaceAbove > spaceBelow);
    }
    if (isOpen && focusSelected && list) {
      var selected = list.querySelector('.hj-cart-item__option-value.is-selected');
      if (selected) selected.focus();
    }
  }

  function closeCartOptionCombos(except, restoreFocus) {
    document.querySelectorAll('[data-cart-option-combo].is-open').forEach(function (combo) {
      if (combo === except) return;
      var trigger = combo.querySelector('[data-action="toggle-cart-option"]');
      setCartOptionOpen(combo, false, false);
      if (restoreFocus && trigger) trigger.focus();
    });
  }

  function selectCartOption(target, card) {
    var combo = target.closest('[data-cart-option-combo]');
    var block = combo && combo.closest('.hj-cart-item__size-block');
    var select = block && block.querySelector('[data-action="change-option"]');
    if (!combo || !select) return;
    var value = target.dataset.value || '';
    var changed = select.value !== value;
    select.value = value;
    var label = combo.querySelector('[data-cart-option-label]');
    if (label) label.textContent = value;
    combo.querySelectorAll('.hj-cart-item__option-value').forEach(function (option) {
      var selected = option === target;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    var trigger = combo.querySelector('[data-action="toggle-cart-option"]');
    setCartOptionOpen(combo, false, false);
    if (trigger) trigger.focus();
    if (changed) changeOption(select, card);
  }

  function toggleDiscount(target) {
    var root = target.closest('[data-discount-collapse]');
    var form = root && root.querySelector('[data-discount-form]');
    if (form) form.hidden = !form.hidden;
  }

  function applyDiscount(target) {
    var root = target.closest('[data-discount-collapse]');
    var input = root && root.querySelector('[data-discount-input]');
    var code = input && input.value ? input.value.trim() : '';
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  document.addEventListener('click', function (event) {
    var target = closestAction(event);
    if (!target) {
      closeCartOptionCombos();
      return;
    }

    var action = target.dataset.action;
    var lineKey = target.dataset.lineKey;
    var card = getLineCard(target);
    var currentQty = getQtyFromCard(card);

    if (action === 'toggle-cart-option') {
      event.preventDefault();
      var combo = target.closest('[data-cart-option-combo]');
      var willOpen = combo && !combo.classList.contains('is-open');
      closeCartOptionCombos(combo);
      setCartOptionOpen(combo, willOpen, false);
      return;
    }

    if (action === 'select-cart-option') {
      event.preventDefault();
      selectCartOption(target, card);
      return;
    }

    closeCartOptionCombos();

    if (action === 'close-cart') {
      event.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      return;
    }

    if (action === 'remove-item') {
      event.preventDefault();
      updateLine(lineKey, 0, card);
      return;
    }

    if (action === 'qty-inc') {
      event.preventDefault();
      updateLine(lineKey, currentQty + 1, card);
      return;
    }

    if (action === 'qty-dec') {
      event.preventDefault();
      updateLine(lineKey, currentQty - 1, card);
      return;
    }

    if (action === 'toggle-discount') {
      event.preventDefault();
      toggleDiscount(target);
      return;
    }

    if (action === 'apply-discount') {
      event.preventDefault();
      applyDiscount(target);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.dataset.action === 'change-option') {
      event.preventDefault();
      event.stopPropagation();
      changeOption(event.target, getLineCard(event.target));
      return;
    }
    if (event.target.dataset.action !== 'change-variant') return;
    event.preventDefault();
    event.stopPropagation();
    changeVariant(event.target.dataset.lineKey, event.target.value, getLineCard(event.target));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var combo = event.target.closest('[data-cart-option-combo]');
    if (!combo || !combo.classList.contains('is-open')) return;
    event.preventDefault();
    closeCartOptionCombos(null, true);
  });

  document.addEventListener('DOMContentLoaded', syncSummaryDetails);
})();
